import { render, staticRenderFns } from "./HistorialDeclaracion.vue?vue&type=template&id=10b671da&"
import script from "./HistorialDeclaracion.vue?vue&type=script&lang=js&"
export * from "./HistorialDeclaracion.vue?vue&type=script&lang=js&"
import style0 from "./HistorialDeclaracion.vue?vue&type=style&index=0&id=10b671da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports